import { type ReactNode } from 'react';
import Spinner from '@/components/Spinner/Spinner';
import StorageErrorBanner from '@/components/StorageErrorBanner/StorageErrorBanner';
import { useHydrated } from '@/store';

type HydrationGuardProps = {
  children: ReactNode;
  hasQuota?: boolean;
};

const HydrationGuard = ({ children, hasQuota = true }: HydrationGuardProps) => {
  const isHydrated = useHydrated();
  if (!isHydrated)
    return (
      <div className='min-h-screen grid place-content-center'>
        <Spinner />
      </div>
    );
  return (
    <>
      {!hasQuota && <StorageErrorBanner />}
      {children}
    </>
  );
};

export default HydrationGuard;
